module.exports = __webpack_public_path__ + "static/media/cone-cream-dessert-2-svgrepo-com.f4e8e05a.svg";